import React from "react";
import { Box, Typography, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { selectChartConfigSettings } from "../../selectors/chart";
import { useSelector, useDispatch } from "react-redux";
import { Settings } from "http2";
import { updateChartConfig } from "../../reducer/chart.reducer";
import { chartSettingsSectionDividerSx, chartSettingsSectionTitleSx } from "./chartSettingsLayout";
type Props = {
    viewKey: string;
};
const StatusLineSettings = ({ viewKey }: Props) => {
    const dispatch = useDispatch();
    const statusLineSettings = useSelector(selectChartConfigSettings(viewKey))

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, field: keyof Settings) => {
        dispatch(updateChartConfig({
            viewKey,
            config: {
                statusLineSettings: {
                    ...statusLineSettings,
                    [field]: event.target.checked
                }
            },
            createIfAbsent: false
        }));
    };

    return (
        <Box>
            <Typography variant="subtitle1" sx={chartSettingsSectionTitleSx}>
                SYMBOL
            </Typography>
            <FormGroup >
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(statusLineSettings?.logo ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "logo" as any)}
                        />
                    }
                    label="Logo"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(statusLineSettings?.showSymbolName ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showSymbolName" as any)}
                        />
                    }
                    label="Title"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(statusLineSettings?.showOHLC ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showOHLC" as any)}
                        />
                    }
                    label="Chart values"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(statusLineSettings?.showBarChange ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showBarChange" as any)}
                        />
                    }
                    label="Bar change values"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!statusLineSettings?.showLastDayChange}
                            onChange={(e) => handleCheckboxChange(e, "showLastDayChange" as any)}
                        />
                    }
                    label="Last day change value"
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!(statusLineSettings?.showExchange ?? true)}
                            onChange={(e) => handleCheckboxChange(e, "showExchange" as any)}
                        />
                    } label={"Exchange"}
                    sx={{
                        ml: 0,
                        "& .MuiFormControlLabel-label": { fontSize: "14px" }
                    }}
                />

            </FormGroup>
            <Typography variant="subtitle1" sx={{ ...chartSettingsSectionTitleSx, ...chartSettingsSectionDividerSx }}>INDICATORS</Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={!!(statusLineSettings?.indicatorTitle ?? true)}
                        onChange={(e) => handleCheckboxChange(e, "indicatorTitle" as any)}
                    />
                }
                label="Titles"
                sx={{
                    ml: 0,
                    display: "block",
                    width: "100%",
                    "& .MuiFormControlLabel-label": { fontSize: "14px" }
                }}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={!!statusLineSettings?.indicatorInputs}
                        onChange={(e) => handleCheckboxChange(e, "indicatorInputs" as any)}
                    />
                }
                label="Inputs"
                sx={{
                    ml: 0,
                    display: "block",
                    width: "100%",
                    "& .MuiFormControlLabel-label": { fontSize: "14px" }
                }}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={!!(statusLineSettings?.indicatorValues ?? true)}
                        onChange={(e) => handleCheckboxChange(e, "indicatorValues" as any)}
                    />
                }
                label="Values"
                sx={{
                    ml: 0,
                    "& .MuiFormControlLabel-label": { fontSize: "14px" }
                }}
            />


        </Box>
    );
};

export default StatusLineSettings;
